// Sidebar.js
export default function Sidebar() {
  return (
    <>
      <p>
        <b>Upcoming events</b>
      </p>
      <p>[Nothing at the moment...]</p>
      <p>
        <b>Past events</b>
      </p>
      <p>
        <i>PolArt Adelaide 2025</i>
        <br />
        Polish Literature Session
        <br />
        30.12.2025 10.00 AM @ Dom Polski Centre, Adelaide, South Australia
        <br />
        Event:{" "}
        <a
          href="https://www.pol.art/events/literature-session-2"
          target="_blank"
          rel="noopener noreferrer"
        >
          PolArt website
        </a>
        <br />
        Media:{" "}
        <a
          href="https://www.facebook.com/share/v/1D6ZErYoQ4/"
          target="_blank"
          rel="noopener noreferrer"
        >
          SBS Polish snippet (from 1:04)
        </a>
      </p>
      <p>
        <i>Literary Club</i>
        <br />
        22.10.25 @
        <br />
        Consulate General of Poland, Sydney
      </p>
      <p>
        <i>PolArt Sydney 2022</i>
        <br />
        Poetry evening @
        <br />
        Foundry 616 Jazz Club, 616 Harris Street Ultimo
      </p>
      <p>
        <i>Poetry Afternoon</i>
        <br />
        26.02.25 @
        <br />
        Polish Club, Ashfield
      </p>
      <p>
        <i>Poetry Afternoon</i>
        <br />
        19.05.24 @
        <br />
        Polish Club, Ashfield
      </p>
      <p>
        <b>Publications</b>
      </p>
      <p>
        <i>Express - The Australian-Polish magazine</i> 11.12.2025
      </p>
      <a
        href="https://polishexpress.au/jolanta-hildebrandt-mazurek/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Polish Express website
      </a>
      <p></p>
    </>
  );
}

/*
      <p>
        <i>CompanyName</i>
        <br />
        EventName @
        <br />
        address
      </p>
*/
